export const matchesFilters = (componentFilters, selectedFilters) => {
  return componentFilters.every(componentFilter => {
    const selectedFilter = selectedFilters.get(componentFilter.name)
    return (selectedFilter?.value === componentFilter.value)
  })
}

/**
 * Identifies one report view. A snapshot is the same reportId with a different snapshotId, so
 * the id alone cannot say whether what is loaded is what is wanted.
 */
export const reportViewKey = ({ reportId, snapshotId }) =>
  `${reportId}:${snapshotId ?? ''}`
